import { MeasurementRequirement, LineMeasurementRequirement, DerivedMeasurementCollection, DerivedMeasurement } from "../Measurements/Measurement";

import { Map } from "immutable";
import { TaskData } from "./Task";
import { EKG_LEAD_ORDER, getCategoricMeasurementFromCollection } from "../Utils";

const _baseRequirements: MeasurementRequirement[] = [
    {
        key: 'calibration',
        type: 'line',
        direction: 'horizontal',
        metadata: {
            name: 'Calibration',
            description: 'The calibration of the ECG. Measure one big square.',
            lead: 'aVL',
            unit: "unitless"
        }
    },
    {
        key: 'st-status',
        type: 'categoric',
        options: ['No', 'Elevation', 'Depression', 'Both'],
        metadata: {
            name: 'ST Segment',
            description: 'Is there any ST segment elevation or depression?',
            lead: 'aVL',
            unit: "unitless"
        }
    },
    {
        key: 'infarct-territory',
        type: 'categoric',
        options: ['Anterior', 'Inferior', 'Lateral', 'Posterior'],
        metadata: {
            name: 'Infarct Territory',
            description: 'The territory of the infarct.',
            lead: 'aVL',
            unit: "unitless"
        },
        shouldSkipRequirement: ({ inputs }) => {
            const stStatus = getCategoricMeasurementFromCollection('st-status', inputs);

            return stStatus?.value === 'No';
        }
    }
]

const _elevationRequirements: LineMeasurementRequirement[] = EKG_LEAD_ORDER.map(lead => ({
    key: `st-elevation-${lead}`,
    type: 'line',
    direction: 'vertical',
    metadata: {
        name: 'ST Elevation',
        description: `The ST elevation in lead ${lead}.`,
        lead,
        unit: 'mV'
    },
    shouldSkipRequirement: ({ inputs }) => {
        const stStatus = getCategoricMeasurementFromCollection('st-status', inputs);

        return stStatus?.value !== 'Elevation' && stStatus?.value !== 'Both';
    }
}));

const _depressionRequirements: LineMeasurementRequirement[] = EKG_LEAD_ORDER.map(lead => ({
    key: `st-depression-${lead}`,
    type: 'line',
    direction: 'vertical',
    metadata: {
        name: 'ST Depression',
        description: `The ST depression in lead ${lead}.`,
        lead,
        unit: 'mV'
    },
    shouldSkipRequirement: ({ inputs }) => {
        const stStatus = getCategoricMeasurementFromCollection('st-status', inputs);

        return stStatus?.value !== 'Depression' && stStatus?.value !== 'Both';
    }
}));

const _finalRequirements: MeasurementRequirement[] = [
    ..._baseRequirements,
    ..._elevationRequirements,
    ..._depressionRequirements
]

const _derivedMeasurements: DerivedMeasurement[] = [];

export const STResolutionTaskData: TaskData = {
    identifier: 'st-resolution',
    requirements: _finalRequirements,
    derivedMeasurements: Map(_derivedMeasurements.map((measurement) => [measurement.key, measurement]))
} as TaskData;

